import EventBus from '@/eventBus'
import Constants from '@/constant'
import Utils from '@/util'

const blockHistoryAction = ({ state }) => {
  state.isBlockHistory = true
}

const unblockHistoryAction = ({ state, dispatch, rootGetters }) => {
  state.isBlockHistory = false
  // When called via Vuex (dispatch is provided), flush any KV-sync canvas-block
  // update that arrived while the editor was focused (AHA-15513).
  if (dispatch && rootGetters?.['featureToggles/canUseContentSlideFix'] && state.pendingCanvasBlockPayload) {
    dispatch('flushPendingCanvasBlockAction')
  }
}

const checkAllowAction = (state) => {
  return !state.isBlockHistory && state.isSyncing === 2
}

const trackUndoRedoEvent = (type, payload) => {
  Utils.mixpanelTracking(
    Constants.eventCategories.PRESENTATION_EDITOR,
    `History > ${Constants.Events.MAP_TYPE_EVENT_HISTORY[type]}`,
    null,
    null,
    payload,
  )
}

const mapDataHistory = {
  undo: {
    undoData: 'undoHistory',
    redoData: 'redoHistory',
    dataBackup: 'data',
  },
  redo: {
    undoData: 'redoHistory',
    redoData: 'undoHistory',
    dataBackup: 'newData',
  },
}

const restoreLatestItem = (state, latest, action) => {
  state[mapDataHistory[action].undoData].push(latest)
}

// const checkCurrentSlideActive = (action, state, latest) => {
//   if (latest.slideActiveId && latest.slideActiveId !== state.slideActive.id) {
//     // restore history
//     restoreLatestItem(state, latest, action)
//     unblockHistoryAction({ state })
//     return false
//   }
//   return true
// }

const checkIsPresenting = ({ getters }) => {
  return getters.isPresenting
}

const handleAction = async ({ getters }, state, action) => {
  const key = `${(new Date()).getTime()}${Math.random().toString(36)}`
  const isPresenting = checkIsPresenting({ getters })
  const allowAction = checkAllowAction(state)

  if (allowAction && !isPresenting && state[mapDataHistory[action].undoData].length) {
    blockHistoryAction({ state })
    const latest = state[mapDataHistory[action].undoData].pop()

    // if (!checkCurrentSlideActive(action, state, latest)) {
    //   setTimeout(() => {
    //     document.body.style.cursor = 'default'
    //   })
    //   return
    // }
    const dataBackup = latest[mapDataHistory[action].dataBackup]
    dataBackup.key = key

    const resultCallFunction = await new Promise((resolve) => {
      EventBus.$emit(
        'callFunction',
        {
          payload: JSON.parse(JSON.stringify(dataBackup)),
          componentName: latest.componentName,
          action,
          type: latest.type,
          callback: (result) => {
            resolve(result)
          },
        },

      )
    })
    if (resultCallFunction === false) {
      restoreLatestItem(state, latest, action)
      unblockHistoryAction({ state })
      Utils.showToastError('The action cannot be performed!')

      return
    }
    trackUndoRedoEvent(action, {
      component_name: latest.componentName,
      type: latest.type,
      presentationId: state.presentation.id,
    })

    delete latest[mapDataHistory[action].dataBackup].key
    state[mapDataHistory[action].redoData].push(JSON.parse(JSON.stringify(latest)))
    unblockHistoryAction({ state })
  }
}

const undoAction = ({ state, getters }) => {
  handleAction({ getters }, state, 'undo')
}

const redoAction = ({ state, getters }) => {
  handleAction({ getters }, state, 'redo')
}

const addActionToHistory = ({ state }, payload) => {
  state.undoHistory.push(payload)
  state.redoHistory = []
}

const clearHistory = ({ state }) => {
  state.undoHistory = []
  state.redoHistory = []
  state.isBlockHistory = false
}

export default {
  blockHistoryAction,
  unblockHistoryAction,
  undoAction,
  redoAction,
  addActionToHistory,
  clearHistory,
}
